import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { invalidateLicenseCache } from '../components/LicenseGuard';

const API = process.env.REACT_APP_BACKEND_URL || '';

const VerifyEmailPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [state, setState] = useState({ loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/auth/verify-email/${token}`);
        if (cancelled) return;
        localStorage.setItem('token', data.access_token);
        if (data.user) {
          localStorage.setItem('user', JSON.stringify(data.user));
        }
        invalidateLicenseCache();
        window.location.href = data.redirect || '/checkout?from=trial';
      } catch (e) {
        if (cancelled) return;
        const detail = e?.response?.data?.detail;
        setState({ loading: false, error: detail || t('verifyEmail.error_default') });
      }
    })();
    return () => { cancelled = true; };
  }, [token, t]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-3xl mb-2">⏳</div>
          <div className="text-gray-600">{t('verifyEmail.loading')}</div>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow p-8 text-center">
        <div className="text-5xl mb-4">⚠️</div>
        <h1 className="text-2xl font-semibold mb-2">{t('verifyEmail.failed_heading')}</h1>
        <p className="text-gray-600 mb-6">{state.error}</p>
        <button onClick={() => navigate('/signup')}
                className="btn-primary">
          {t('verifyEmail.retry_cta')}
        </button>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
